// @ts-nocheck

import { map } from 'lodash';
import URIParser from 'query-string';

import { Target } from '../client';
import { getAppDOMElement } from '../DOMElements';

export { default as common } from './common';
export { default as storage } from './storage';
export { default as number } from './number';
export { default as bet } from './bet';
export { default as entity } from './entity';
export { default as match } from './match';
export { default as odd } from './odd';
export { default as basket } from './basket';
export { default as user } from './user';
export { default as webShare } from './webShare';
export { default as compose } from './compose';
export { default as createReducer } from './createReducer';
export { default as base64 } from './base64';
export { default as getBetslipNotableCase } from './getBetslipNotableCase';
export { default as getSystemTitle } from './getSystemTitle';
export { default as roundBoosterPercent } from './roundBoosterPercent';
export { default as device } from './device';
export { default as betbuilder } from './betbuilder';
export { default as color } from './color';

export const shallowEqual = (objA, objB) => {
  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (let i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
};

export const scrollToTop = () => {
  if (Target.__MOBILE__) {
    getAppDOMElement().scrollTop = 0;
  } else {
    window?.scrollTo(0, 0);
  }
};

export const triggerScroll = () => {
  if (window !== undefined) {
    window.scrollBy(0, 0);
  }
};

export const getQuerystringParam = (name, from = window?.location?.search) => {
  if (window !== undefined) {
    const match = new RegExp('[?&]' + name + '=([^&]*)').exec(from);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }
};

export const parseUrl = (url) => (url ? URIParser.parseUrl(url) : {});

export const getCurrentURIParams = (uri = window?.location?.search) => {
  return uri ? URIParser.parse(uri) : {};
};

export const formatQuerystringParams = (params) => {
  let result = '';

  let i = 0;
  for (const key in params) {
    if (i) {
      result += '&';
    }

    let value = params[key];
    if (value instanceof Array) {
      result += key + '[]=' + map(value, encodeURIComponent).join('&' + key + '[]=');
    } else {
      if (!value && value !== 0) {
        value = '';
      }
      result += key + '=' + encodeURIComponent('' + value);
    }

    i++;
  }

  if (i === 0) {
    return '';
  }

  return '?' + result;
};

export const getCustomHeaders = (datas) => {
  const customHeaders = {};

  if (datas.jwt) {
    customHeaders['X-Token'] = datas.jwt;
  }
  if (datas.sessionId) {
    customHeaders['X-SessionId'] = datas.sessionId;
  }
  if (datas.cc) {
    customHeaders['X-CommId'] = datas.cc;
  }
  if (datas.tracker) {
    customHeaders['X-Tracker'] = datas.tracker;
  }

  return customHeaders;
};

export const showWebsiteLoginForm = () => {
  if (!Target.__MOBILE__ && window && typeof window.showLoginForm === 'function') {
    window.showLoginForm();
  }
};
